import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import '@angular/compiler';

import 'hammerjs';
import 'hammer-timejs';

import { LogService } from './app/services/log.service';

if (environment.production) {
  enableProdMode();
}

const logger = new LogService();

platformBrowserDynamic().bootstrapModule(AppModule)
.catch(err => console.log(err))
.then(() => {
  logger.info("main","main", "AppModule loaded")
});
